export default function () {
    const $route = useRoute();
    const functions = useUtilityFunctions();

    function route(video) {
        const route = functions.cloneObject(video.video_route);
        route.query = {};
        switch ($route.name) {
            case 'events-eventSlug':
                route.query.context = $route.query.context || 'event';
                route.query.eventSlug = $route.params.eventSlug;
                break;
            case 'dancers-dancerSlug':
                route.query.context = $route.query.context || 'dancer';
                route.query.dancerSlug = $route.params.dancerSlug;
                break;
            case 'videos':
                route.query.context = $route.query.context || 'videos';
                break;
            default:
                route.query.context = $route.query.context || 'home';
                route.query.eventSlug = $route.query.eventSlug || undefined;
                route.query.dancerSlug = $route.query.dancerSlug || undefined;
                break;
        }
        return route;
    }

    function title() {
        return 'Video';
    }

    function parent() {
        if ($route.query.context === 'event' && $route.query.eventSlug) {
            return {
                title: 'Event',
                route: `/events/${$route.query.eventSlug}`,
            };
        }
        if ($route.query.context === 'dancer' && $route.query.dancerSlug) {
            return {
                title: 'Dancer',
                route: `/dancers/${$route.query.dancerSlug}`,
            };
        }
        if ($route.query.context === 'videos') {
            return {
                title: 'Home',
                route: '/videos',
            };
        }
        return {
            title: 'Home',
            route: '/',
        };
    }

    return {route, title, parent};
}
